import React from "react";
import CardAddItem from "components/Cards/CardAddItem";

export default function Settings() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full px-4">
          <CardAddItem />
        </div>
      </div>
    </>
  );
}